const list = [];
let isLoaded = false;

export function load(callback) {
    if (isLoaded || document.readyState === 'interactive' || document.readyState === 'complete') {
        callback();
    } else {
        list.push(callback);
    }
}

document.addEventListener("DOMContentLoaded", () => {
    isLoaded = true;
    list.forEach((callback) => callback());
});

window.load = load;
